import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import axios, { AxiosError } from "axios";

import { resolveBackofficeOrigin } from "@qubictron/url/client";

interface RetryConfig extends InternalAxiosRequestConfig {
  _retried?: boolean;
}

const CSRF_COOKIE_URL = "/sanctum/csrf-cookie";

const authInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,

    async (err: AxiosError) => {
      const originalRequest: RetryConfig | undefined = err.config;
      const isCsrfError = err.response?.status === 419;

      // Retry once: flag travels with the config object through Axios internals
      if (isCsrfError && originalRequest && !originalRequest._retried) {
        originalRequest._retried = true;
        await axiosInstance.get(CSRF_COOKIE_URL, {
          withCredentials: true,
        });
        return axiosInstance(originalRequest);
      }

      return Promise.reject(err);
    }
  );
};

const apiClient = axios.create({
  baseURL: resolveBackofficeOrigin(),
  withCredentials: true,
  withXSRFToken: true,

  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
});

authInterceptor(apiClient);

export default apiClient;
